import { useState, useEffect, useRef } from "react";
import PlanTile from "./PlanTile.tsx";
import RazorpayPayButton from "../RazorpayPayButton.jsx";

const PLANS = [
{
id: "PREMIUM_UNLOCK",
name: "Premium Unlock",
price: 199,
original: 399,
features: [
"Personality Traits",
"Planet in Houses",
"Awareness Areas",
"Karmic Remedies",
"Interpretation layers -Summary",
"PDF export not included",
],
},
{
id: "GROWTH",
name: "Growth",
price: 299,
original: 599,
features: [
"Everything in Premium",
"Export full PDF report",
],
},
{
id: "INSIGHT",
name: "Insight",
price: 499,
original: 999,
features: [
"Everything in Growth",
"Interpretive layers -Detailed",
"Expanded synthesis insights",
],
},
];


export default function UpgradeModal({ chartId, onClose }) {
const [selectedPlan, setSelectedPlan] = useState(null);

const paymentRef = useRef(null);
const modalRef = useRef(null);

const selected = PLANS.find((p) => p.id === selectedPlan);


useEffect(() => {
document.body.style.overflow = "hidden";


const tabs = document.querySelector(".floating-tab-switcher");
if (tabs) tabs.style.visibility = "hidden";

return () => {
  document.body.style.overflow = "auto";
  if (tabs) tabs.style.visibility = "visible";
};


}, []);

const handleSelect = (planId) => {
setSelectedPlan(planId);


setTimeout(() => {
  if (!paymentRef.current || !modalRef.current) return;

  const modal = modalRef.current;
  const paymentTop = paymentRef.current.offsetTop;

  modal.scrollTo({
    top: paymentTop - 40,
    behavior: "smooth",
  });
}, 120);


};

return ( <div className="upgrade-overlay"> <div className="upgrade-modal" ref={modalRef}>


    <h2>Unlock Deeper Chart Insights</h2>

    <p className="launch-note">
      🎉 Launch Offer — Early users receive special pricing
    </p>

    <div className="tiles-grid">
      {PLANS.map((plan) => (
        <PlanTile
          key={plan.id}
          plan={plan}
          selected={selectedPlan === plan.id}
          onSelect={() => handleSelect(plan.id)}
        />
      ))}
    </div>

    {selected && (
      <div className="plan-details">
        <h3>{selected.name}</h3>

        <ul>
          {selected.features.map((f, i) => (
            <li key={i}>{f}</li>
          ))}
        </ul>
      </div>
    )}

    {selected && (
      <div ref={paymentRef} className="payment-area">

        <RazorpayPayButton
          chartId={chartId}
          plan={selected.id}
          amount={selected.price}
        />

      </div>
    )}

    <div className="upgrade-footer">
      Astrology interpreted as structured awareness — not prediction.
    </div>

    <button className="close-btn" onClick={onClose}>
      Close
    </button>

  </div>
</div>


);
}
